import {
  AccountCircleRounded,
  GavelRounded,
  SettingsRounded,
} from "@mui/icons-material";
import { Button, Stack, ThemeProvider, createTheme } from "@mui/material";
import React, { useState } from "react";

function ProfileMenu({ handleProfile }) {
  const [color1, setColor1] = useState("red");
  const [color2, setColor2] = useState("black");
  const [color3, setColor3] = useState("black");
  const theme = createTheme({
    typography: {
      fontFamily: [
        "Assistant",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(","),
    },
  });

  const menuButtonSx = (active) => ({
    width: "100%",
    minHeight: 52,
    justifyContent: "flex-start",
    gap: 1.25,
    px: 2,
    py: 1.25,
    borderRadius: "14px",
    color: active ? "#1565C0" : "#334155",
    backgroundColor: active ? "#EAF4FF" : "transparent",
    border: active ? "1px solid #B9DCFF" : "1px solid transparent",
    boxShadow: active ? "0 7px 18px rgba(21,101,192,.10)" : "none",
    fontFamily: `${process.env.REACT_APP_FONT}`,
    fontWeight: 800,
    fontSize: "15px",
    textTransform: "none",
    transition: "all .18s ease",
    "& .MuiSvgIcon-root": {
      fontSize: 22,
      color: active ? "#1565C0" : "#64748B",
    },
    "&:hover": {
      backgroundColor: active ? "#E4F1FF" : "#F5F9FD",
      borderColor: active ? "#A9D4FF" : "#DCEAF7",
      transform: "translateY(-1px)",
    },
    "@media (max-width: 899px)": {
      flex: "1 1 0",
      minWidth: 0,
      width: "33.333%",
      minHeight: 62,
      px: 0.5,
      py: 0.75,
      gap: 0.35,
      borderRadius: "12px",
      justifyContent: "center",
      fontSize: "clamp(13px, 3.4vw, 15px)",
      lineHeight: 1.15,
      whiteSpace: "normal",
      textAlign: "center",
      overflowWrap: "anywhere",
      "& .MuiButton-startIcon": {
        margin: 0,
        flexShrink: 0,
      },
      "& .MuiSvgIcon-root": {
        fontSize: 19,
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <Stack
        flex={1}
        p={{ xs: 1, md: 2 }}
        direction={{ xs: "row", md: "column" }}
        spacing={1}
        sx={{
          fontFamily: `${process.env.REACT_APP_FONT}`,
          fontWeight: "bold",
          textAlign: "center",
          alignSelf: { md: "flex-start" },
          position: { md: "sticky" },
          top: { md: 88 },
          minWidth: { md: 235 },
          maxWidth: { xs: "100%", md: 270 },
          width: { xs: "100%", md: "auto" },
          overflowX: "hidden",
          backgroundColor: "#FFFFFF",
          border: "1px solid #E3EDF6",
          borderRadius: { xs: "16px", md: "20px" },
          boxShadow: "0 12px 32px rgba(15,45,75,.08)",
          boxSizing: "border-box",
          "&::-webkit-scrollbar": { display: "none" },
        }}
      >
        <Button
          onClick={(e) => {
            setColor1("red");
            setColor2("black");
            setColor3("black");
            handleProfile("about");
          }}
          variant="text"
          startIcon={<AccountCircleRounded />}
          sx={menuButtonSx(color1 === "red")}
        >
          <span style={{ fontWeight: "bold" }}>הפרופיל שלי</span>
        </Button>
        <Button
          onClick={(e) => {
            setColor2("red");
            setColor1("black");
            setColor3("black");
            handleProfile("settings");
          }}
          variant="text"
          startIcon={<SettingsRounded />}
          sx={menuButtonSx(color2 === "red")}
        >
          הגדרות​
        </Button>
        <Button
          onClick={(e) => {
            setColor3("red");
            setColor1("black");
            setColor2("black");
            handleProfile("bids");
          }}
          variant="text"
          startIcon={<GavelRounded />}
          sx={menuButtonSx(color3 === "red")}
        >
          המכרזים שלי
        </Button>
      </Stack>
    </ThemeProvider>
  );
}

export default ProfileMenu;
